export default class Accordion {
	constructor(private $el: HTMLElement) {
		this.init();
	}

	private init() {
		const toggle = this.toggle.bind(this);
		Array.from<HTMLElement>(this.$el.querySelectorAll('.accordion-item__title')).forEach((title) => {
			console.log();
			title.addEventListener('click', toggle);
		});
	}

	// eslint-disable-next-line class-methods-use-this
	private toggle(event: Event) {
		if (event.target) {
			const $target = event.target as HTMLElement;
			const $parent = $target.closest('.accordion-item');
			if ($parent) {
				$parent.classList.toggle('accordion-item--open');
				const $panel: HTMLElement | null = $parent.querySelector('.accordion-item__content');
				if (!$panel) {
					return;
				}
				if ($panel.style.maxHeight) {
					$panel.style.maxHeight = '';
				} else {
					$panel.style.maxHeight = `${$panel.scrollHeight}px`;
				}
			}
		}
	}
}
